import { FC } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';
import { usePathname } from '@telialt/utils/src/pathname';

import { getIsLinkActive } from '../../utils/path';
import { MenuItemNamedIcon, StyledMenuItem } from './MenuItem.styles';

interface Props {
    item: NavigationItem;
}

export const MenuItemLink: FC<Props> = ({ item }) => {
    const { title, url, colorOption, displayOption, icon } = item;
    const pathname = usePathname();
    const isActive = url ? getIsLinkActive(url, pathname) : false;

    return (
        <StyledMenuItem
            $displayOption={displayOption}
            $isActive={isActive}
            aria-current={isActive ? 'page' : undefined}
            $colorOption={colorOption}
            href={url}
            data-element="Link"
            data-element-name={title}
            data-element-color-option={colorOption}
        >
            {title}
            {icon && <MenuItemNamedIcon name={icon} size="sm" />}
        </StyledMenuItem>
    );
};
